import React from "react";
//import PropTypes from 'prop-types';

export function SelectListLabel(props) {
    const { children } = props;
    return <div className={"select-list-label"}>{children}</div>;
}

SelectListLabel.propTypes = {};

SelectListLabel.defaultProps = {};

export default SelectListLabel;
